import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useHttpClient } from '../../shared/http-client';
import { StoreKeys, useStore } from '../../shared/store';
import { APP_NAME } from '../../constants';
import LOGO from '../../../assets/images/xtremislogo.png';
import { PadlockIcon } from './icons/PadlockIcon';
import { LogoVertIcon } from './icons/LogoVertIcon';

export const Login = () => {
    const { t } = useTranslation();
    const { i18n } = useTranslation();
    let lng = localStorage.getItem('i18nextLng');
    const [language, setLanguage] = useState(lng || 'en');
    const navigate = useNavigate();
    const { api, state } = useHttpClient();
    const { set } = useStore();
    const [formState, setFormState] = React.useState({
        email: '',
        password: ''
    });
    const [isLoginSuccess, setIsLoginSuccess] = useState(false);

    const handleLangChange = (evt: any) => {
        const lang = evt.target.value;
        console.log(lang);
        setLanguage(lang);
        i18n.changeLanguage(lang);
        localStorage.setItem('i18nextLng', lang);
    };

    useEffect(() => {
        if (state.data) {
            if (state.path.includes('login')) {
                set(StoreKeys.Token, state.data);
                set(StoreKeys.Profile, state.data.user);
            }
            setIsLoginSuccess(true);
            setTimeout(() => {
                navigate('/');
                window.location.reload();
            }, 1000); // 1-second delay for animation
        }

        if (state.error) {
            if (state.error.non_field_errors) {
                toast.error(`${t("login.error")}`);
            } else {
                toast.error('Server Error');
            }
        }
    }, [state]);

    const handleChange = (e: any) => {
        setFormState((prev) => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    };

    const handleLogin = async () => {
        api('/auth/login/', 'POST', formState);
    };

    return (
        <div className="flex flex-col justify-center items-center pb-12 sm:px-6 lg:px-8 h-screen ">
            <div className="w-full bg-gray-100 text-gray-700 text-center text-sm font-medium py-2 px-4 fixed top-0 left-0 z-50 border-b border-gray-300">
                Demo operated by Xtremis for {APP_NAME} — test data
            </div>
            {/* <div className="flex justify-center items-center py-12 sm:px-6 lg:px-8 h-screen bg-custom-bg bg-cover bg-center "> */}
            <div className="flex bg-[#1c1d3d] bg-center h-[550px] w-[500px] rounded-lg">
                <div className="relative w-full">
                    <div className="absolute -top-12 left-1/2 -translate-x-1/2 transform">
                        <PadlockIcon
                            color="#006bc6"
                            isUnlocked={isLoginSuccess}
                            className={`h-16 w-16 transition-transform duration-8900 ease-in-out ${isLoginSuccess ? 'scale-110' : ''
                                }`}
                        />
                    </div>
                    <div className="w-full px-4 flex justify-center">
                        <div>
                            <div className="w-[300px] flex justify-center pb-[5px] text-white text-3xl font-bold">
                                <div className="w-full flex justify-center flex-col">
                                    <div className="flex justify-center py-8">
                                        <img
                                            className="h-8 w-auto"
                                            src={LOGO}
                                            alt="Workflow"
                                        />
                                        {/*   <LogoVertIcon  /> */}
                                    </div>
                                </div>

                                {/*  */}
                            </div>
                            <div className="w-[300px]">
                                <select
                                    onChange={handleLangChange}
                                    value={language}
                                    className="w-[300px] bg-[#1c1d3d] px-3 py-2 border-b-1 border-gray-700 placeholder-white text-white text-[15px]"
                                >
                                    <option value="en">{t('EN')}</option>
                                    <option value="es">{t('ES')}</option>
                                    <option value="fr">{t('FR')}</option>
                                    <option value="it">{t('IT')}</option>
                                </select>
                            </div>
                            <div className="pt-[15px]">
                                <label className="block text-sm font-medium text-white">
                                    {t('login.text.email')}*
                                </label>
                                <div className="mt-1">
                                    <input
                                        id="email"
                                        name="email"
                                        type="email"
                                        autoComplete="email"
                                        required
                                        value={formState.email || ''}
                                        onChange={handleChange}
                                        className="w-[300px] bg-transparent px-3 py-2 border-b-1 border-gray-700 placeholder-white text-white text-[15px]"
                                    />
                                </div>
                            </div>
                            <div className="pt-[15px]">
                                <label className="block text-sm text-white">
                                    {' '}
                                    {t('login.text.password')}*{' '}
                                </label>
                                <div className="mt-1">
                                    <input
                                        id="password"
                                        name="password"
                                        type="password"
                                        autoComplete="current-password"
                                        required
                                        value={formState.password || ''}
                                        onChange={handleChange}
                                        className="w-[300px] bg-transparent px-3 py-2 border-b-1 border-gray-700 placeholder-white text-white"
                                    />
                                </div>
                            </div>
                            <div className="text-sm py-[15px] flex justify-end">
                                <Link to="/forgot">
                                    <div className="text-white">
                                        {t('login.text.forgot.password')}
                                    </div>
                                </Link>
                            </div>
                            <div>
                                <button
                                    type="submit"
                                    onClick={handleLogin}
                                    className="w-[300px] rounded-[50px] flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm  text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-dark"
                                >
                                    {t('login.button.login')}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

